import { render, staticRenderFns } from "./singlechoice.vue?vue&type=template&id=b8ad19ec&"
import script from "./singlechoice.vue?vue&type=script&lang=ts&"
export * from "./singlechoice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "singlechoice.vue"
export default component.exports